import { HostEditActionDefinition } from '@wix/editor-platform-host-integration-apis';

import { GroupedNativeActions } from './groupNativeActions';
import { getResolvedHostEditActions } from './getResolvedEditActions';
import {
  PlatformContext,
  CustomManifestAction,
  EditActionsDictionary,
} from '../types';

export function customizeNativeActions<
  TActions extends GroupedNativeActions['customizedNativeActions'],
  TResult extends
    | HostEditActionDefinition
    | CustomManifestAction = HostEditActionDefinition,
>(
  actions: TActions,
  platformContext: PlatformContext,
): EditActionsDictionary<TResult> {
  const resolvedContributedActions =
    getResolvedHostEditActions<HostEditActionDefinition>(
      actions,
      platformContext,
    );

  return resolvedContributedActions.reduce<EditActionsDictionary<TResult>>(
    (acc, action) => {
      acc[action.actionName] = {
        ...actions[action.actionName],
        ...action,
      } as TResult;
      return acc;
    },
    {},
  );
}
